import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageCheckoutComplete = lazy(() => import("./layout/index"));

export const routerPageStoreCheckoutComplete: RouterItemType = {
  path: "/store/checkout/complete",
  authorize: true,
  element: <LayoutPageCheckoutComplete />,
};
